var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-inner-loading',{attrs:{"showing":_vm.getOrderPending || _vm.loading}},[_c('div',[_c('q-spinner',{attrs:{"color":"primary","thickness":2,"size":"3em"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }